import { observer } from "mobx-react";
import './email-colors-editor.scss';
import { FormField } from "../../../../components/form-field/form-field";
import ColorPickerInput from "../../../look-and-feel/components/color-picker-input/color-picker-input";
import emailCustomizationStore from "../../stores/email-customization-store";
import FontHeading5 from "../../../../components/fonts/font-heading5/font-heading5";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";


const EmailColorstEditor: React.FC = observer(() => {
    const getColorCodeForInput = (hex?: string): string | undefined => {
        return hex?.substring(1);
    }

    const convertColorCodetoHex = (code: string): string => {
        return '#' + code;
    }

    return (
        <div className='email-colors-editor'>
            <FontHeading5 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                Modify Colors
            </FontHeading5>
            <FontHeading5>
                Modify the text, background, and link colors in emails sent to your customers. You can always revert back to the default colors.
            </FontHeading5>
            <div className="color-list">
                <FormField label='Background'>
                    <ColorPickerInput
                        onChange={(v) => emailCustomizationStore.setBackgroundColor(convertColorCodetoHex(v))}
                        value={getColorCodeForInput(emailCustomizationStore.backgroundColor)}
                    />
                </FormField>
                <FormField label='Text'>
                    <ColorPickerInput
                        onChange={(v) => emailCustomizationStore.setTextColor(convertColorCodetoHex(v))}
                        value={getColorCodeForInput(emailCustomizationStore.textColor)}
                    />
                </FormField>
                <FormField label='Link'>
                    <ColorPickerInput
                        onChange={(v) => emailCustomizationStore.setLinkColor(convertColorCodetoHex(v))}
                        value={getColorCodeForInput(emailCustomizationStore.linkColor)}
                    />
                </FormField>
                <FormField label='Button background'>
                    <ColorPickerInput
                        onChange={(v) => emailCustomizationStore.setButtonBackgroundColor(convertColorCodetoHex(v))}
                        value={getColorCodeForInput(emailCustomizationStore.buttonBackgroundColor)}
                    />
                </FormField>
                <FormField label='Button text'>
                    <ColorPickerInput
                        onChange={(v) => emailCustomizationStore.setButtonTextColor(convertColorCodetoHex(v))}
                        value={getColorCodeForInput(emailCustomizationStore.buttonTextColor)}
                    />
                </FormField>
            </div>
        </div>
    );
});

export default EmailColorstEditor;
